import MiniMasonry from 'minimasonry';

const initGallery = (gallery) => {
    const masonry = new MiniMasonry({
        container: gallery,
        gutter: 16,
        surroundingGutter: true,
        baseWidth: 350,
    });

    const relayout = () => {
        masonry.layout();
        if (typeof AOS !== 'undefined' && typeof AOS.refresh === 'function') {
            AOS.refresh();
        }
    };

    gallery.querySelectorAll('img').forEach((img) => {
        if (!img.complete) {
            img.addEventListener('load', relayout, { once: true });
            img.addEventListener('error', relayout, { once: true });
        }
    });

    window.addEventListener('load', relayout, { once: true });
    relayout();
};

const boot = () => {
    document.querySelectorAll('.masonry-gallery').forEach(initGallery);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
    boot();
}
